import { ReactComponent as PinnIcon } from '@/assets/icons/pinn-icon.svg'
import { ReactComponent as XBadgeIcon } from '@/assets/icons/x-badge-icon.svg'
import { ReactComponent as ArchiveIcon } from '@/assets/icons/archive-solid.svg'

import { ReactComponent as TrashIcon } from '@/assets/icons/trash-icon.svg'
import { ReactComponent as SentIcon } from '@/assets/icons/sent-solid.svg'
import { ReactComponent as DocumentIcon } from '@/assets/icons/document-solid.svg'

import './GroupButtons.scoped.sass'

import threadsService from '@/app-domains/threads/threads.service'
import commonsService from '@/services/commons.service'

export function GroupButtons ({ selectArchived, selectedLabel, setSelectedLabel, showInLabelsSection }) {
  async function setGroupFilter (filterName, filterType) {
    if (filterName === 'Drafts') return commonsService.goToPage('/drafts')
    const filterData = {
      type: filterType,
      scope: ['message'],
      label: filterName,
      value: filterType,
    }
    await threadsService.applyFilter(filterData)
  }

  const selectGroup = (name) => {
    if (name === 'Archived') {
      selectArchived()
      setGroupFilter(name, name)
    } else {
      setGroupFilter(name, name)
      setSelectedLabel(name)
    }
  }

  const labels = showInLabelsSection
    ? [{
        name: 'Archived',
        icon: <ArchiveIcon />
      }, {
        name: 'Promotional',
        icon: <XBadgeIcon />
      }, {
        name: 'Spam',
        icon: <XBadgeIcon />
      }]
    : [{
        name: 'Pinned',
        icon: <PinnIcon />
      }, {
        name: 'Drafts',
        icon: <DocumentIcon />
      },
      {
        name: 'Sent',
        icon: <SentIcon />
      },
      {
        name: 'Deleted',
        icon: <TrashIcon />
      }]
      
  return labels.map(({ name, icon }, index) => {
    return <li
      style={{ 'padding-top': '0.8rem', 'padding-bottom': '0.8rem' }}
      key={index} className={`group-button-item ${selectedLabel === name ? 'active' : ''}`} onClick={() => selectGroup(name)}>
      <div className="label-left">
        <span className='label-icon'>
          {icon}
        </span>
        {name}
      </div>
    </li>
  })
}
